import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const RepaymentInterestModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  interestAmount, onInterestAmountChange, interestAmountError, setInterestAmountError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Adjust Interest'
    buttonLabel='Pay'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='interestAmount' required={true} label='Interest amount'
      value={interestAmount} onChange={onInterestAmountChange}
      error={interestAmountError} setError={setInterestAmountError}
      autoFocus={true}
    />

  </ModalFormUI>

export default RepaymentInterestModalUI
